module.exports = ".align-buttons {\n  text-align: right; }\n\ntd {\n  border: 1px solid; }\n\n.pdf-container {\n  width: 100%; }\n\n.higher {\n  background: #D6D6D6; }\n\n.table {\n  margin: 5px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-create-pdf-catalogue/master-create-pdf-catalogue.component.scss
// module id = ./src/app/master/master-create-pdf-catalogue/master-create-pdf-catalogue.component.scss
// module chunks = main